<template>
  <div class="prehome" v-if="!getIsAdult && getPrehomeTrans && getTranslationsAPI">
    <h1 class="title">{{getTranslationsAPI.prehome_title}}</h1>
    <div class="wrapper">
      <h2 class="hello">{{getPrehomeTrans.hello}}</h2>
      <h1 class="question">{{getPrehomeTrans.question}}</h1>
      <div class="answers">
        <button class="prehome-btn" @click="yes">{{getPrehomeTrans.yes}}</button>
        <span class="separator">&#8203;</span>
        <button class="prehome-btn" @click="showModal = true">{{getPrehomeTrans.no}}</button>
      </div>
      <p class="advise">{{getTranslationsAPI.prehome_subtitle}} {{getGrade}}º</p>
    </div>
    <vue-final-modal
      v-model="showModal"
      name="noModal"
      classes="modal-container"
      content-class="modal-content">
        <h2 class="hello">{{getPrehomeTrans.hello}}</h2>
        <h1 class="question">{{getPrehomeTrans.modal_title}}</h1>
        <p class="advise">{{getTranslationsAPI.prehome_subtitle}} {{getGrade}}º</p>
        <button class="prehome-btn mt-8" @click="showModal = false">{{getPrehomeTrans.modal_ok}}</button>
    </vue-final-modal>
  </div>
</template>

<script>
import { VueFinalModal } from 'vue-final-modal'
import router from '@/router/index.js'
import { mapGetters, mapMutations, mapState } from 'vuex'
import ApiService from '@/services/ApiService'
import LocalStorageService from '@/services/LocalStorageService'

export default {
  name: 'PreHome',
  data () {
    return {
      showModal: false
    }
  },
  components: {
    VueFinalModal
  },
  computed: {
    ...mapState(['videoId']),
    ...mapGetters(['getIsAdult', 'getPrehomeTrans', 'getTranslationsAPI', 'getGrade'])
  },
  methods: {
    ...mapMutations(['setConfig', 'setCodeLangs', 'setTranslationsAPI', 'setIsAdult', 'setEmail', 'changeLoading']),
    yes () {
      this.setIsAdult(true)
      localStorage.setItem('isAdult', true)
      const partialPath = this.$route.params.preview === 'preview' ? `/${this.$route.params.alias_url}/preview` : `/${this.$route.params.alias_url}`
      if (this.videoId) {
        router.push({ path: `${partialPath}/video/${this.videoId}` })
      } else {
        router.push({ path: `${partialPath}/home` })
      }
    },
    async getContest (params) {
      this.changeLoading(true)
      try {
        const response = await ApiService.getAvailableContest(params)
        const responseData = response.data.data
        const partialPath = params.preview === 'preview' ? `/${params.alias_url}/preview` : `/${params.alias_url}`
        if (response.data.code === 200) {
          this.setCodeLangs(responseData.contest.code_langs)
          this.setConfig(responseData.contest.template_config)
          this.setTranslationsAPI(responseData.contest.cms_translation)
          document.documentElement.style.setProperty('--primary', responseData.contest.template_config.brand_color)
          document.documentElement.style.setProperty('--star', responseData.contest.template_config.star_color)
          this.setEmail(LocalStorageService.getParsed('userEmail'))
          if (LocalStorageService.ifTrue('isAdult')) {
            this.setIsAdult(true)
            router.push({ path: `${partialPath}/home` })
          }
          this.changeLoading(false)
        } else {
          router.push({ path: '/' })
          this.changeLoading(false)
        }
      } catch (error) {
        this.changeLoading(false)
        router.push({ path: '/' })
      }
    }
  },
  created () {
    const params = {
      alias_url: this.$route.params.alias_url,
      preview: this.$route.params.preview === 'preview' ? this.$route.params.preview : ''
    }
    this.getContest(params)
  }
}
</script>

<style scoped>
.prehome {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-family: Poppins,sans-serif;
  min-height: 100vh;
}
.title {
  font-weight: 700;
  font-size: 3rem;
  line-height: 1;
  margin-bottom: 2rem;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  width: 700px;
}
@media (max-width: 767.9px) {
  .title {
    width: 370px;
  }
}
.wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  text-align: center;
  width: 700px;
}
@media (max-width: 767.9px) {
  .wrapper {
    width: 370px;
  }
}
.hello {
  font-weight: 900;
  margin-bottom: 1rem;
}
.question {
  font-family: Poppins,sans-serif;
  font-weight: 900;
  font-size: 2.25rem;
  line-height: 2.5rem;
  margin-bottom: 1rem;
  text-align: center;
}
.answers {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-bottom: 2rem;
}
.prehome-btn {
  font-family: Poppins,sans-serif;
  font-weight: 900;
  font-size: 2.25rem;
  line-height: 2.5rem;
  margin-left: 1rem;
  margin-right: 1rem;
  -webkit-transition-property: all;
  -o-transition-property: all;
  transition-property: all;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  transform: scale(100%);
}
.prehome-btn:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.prehome-btn:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.prehome-btn:hover {
  transform: scale(110%);
}
.separator {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
  border-style: solid;
  border-right-width: 1px;
  border-width: 2px;
  font-size: 1.5rem;
  line-height: 2rem;
}
.advise {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
:deep(.modal-container) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  padding: 1rem;
}
:deep(.modal-content) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.75rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -ms-flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin: auto;
  padding: 2rem;
  text-align: center;
}
</style>
